export default "__VITE_ASSET__CZmwaTHh__"